<template>
  <v-card elevation="2" outlined shaped tile class="my-4">
    <v-card-title>
      <div @click="expand = !expand" :style="{ cursor: 'pointer' }">Guideline</div>
      <div class="ml-2">
        <v-btn icon color="green" @click="moveUp(section.id)">
          <v-icon>mdi-arrow-up-bold-box</v-icon>
        </v-btn>
        <v-btn icon color="red" @click="moveDown(section.id)">
          <v-icon>mdi-arrow-down-bold-box</v-icon>
        </v-btn>
      </div>
    </v-card-title>
    <v-card-subtitle v-if="expand">
      <div>ID: {{ section.id }}</div>
      <div>Type: {{ section.type }}</div>
      <div>Sort Order: {{ section.sort_order }}</div>
      <div>Children Count: {{ section.children.length }}</div>
    </v-card-subtitle>
    <v-card-text v-if="expand">
      <div class="d-flex flex-wrap">
        <v-flex md6 xs12 v-for="child in children" :key="child.id">
          <home-feed-guideline-child :child="child" :onChildChange="onChildChange" />
        </v-flex>
        <v-flex xs12 class="mt-6 mb-2">
          <v-text-field label="Title" v-model="section.title" dense></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-text-field label="Subtitle" v-model="section.subtitle" dense></v-text-field>
        </v-flex>
      </div>
    </v-card-text>
    <v-card-actions v-if="expand">
      <v-btn color="primary" @click="save">Save</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { Vue } from 'vue-property-decorator';
import HomeFeedGuidelineChild from './HomeFeedGuidelineChild.vue';
import homefeedService from '../../../services/homefeed';
export default Vue.extend({
  components: {
    HomeFeedGuidelineChild,
  },
  data: () => ({
    expand: false,
  }),
  computed: {
    children() {
      const children = this.section.children || [];
      children.push({
        section_id: this.section.id,
        type: 'guideline',
        attributes: {},
      });
      return children;
    },
  },
  props: {
    section: {
      type: Object,
      required: true,
    },
    moveUp: {
      type: Function,
      required: true,
    },
    moveDown: {
      type: Function,
      required: true,
    },
    onChildChange: {
      type: Function,
      required: true,
    },
  },
  methods: {
    async save() {
      const requestBody = {
        title: this.section.title,
        subtitle: this.section.subtitle,
      };

      await homefeedService.updateSection(this.section.id, requestBody);
      console.log('Successfully updated section ID:', this.section.id);
    },
  },
});
</script>

<style scoped></style>
